import { Client } from './http';
import { removeStartingSlash, removeTrailingSlash } from './string-helpers';
import { WeakType } from '../typescript-migration';

const serviceURL = 'wolf-athenaeum-service';

export class ClientFactory {
  static HttpClient(payload: WeakType): Client {
    const baseUrl = `${removeTrailingSlash(
      payload.baseGatewayAPIUrl,
    )}/${removeStartingSlash(serviceURL)}`;

    return new Client({ ...payload, baseUrl });
  }
}
